<template>
  <div>
    <ul class="select-option" style="overflow: hidden">
      <li>
        <span class="select-title">事件ID：</span>
        <el-input
          v-model="caseId"
          placeholder="请输入事件ID"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">受助人姓名：</span>
        <el-input
          v-model="realName"
          placeholder="受助人姓名"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>

      <li>
        <span class="select-title">受助人身份证号：</span>
        <el-input
          v-model="idCard"
          maxlength="18"
          placeholder="受助人身份证号"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">处理人姓名：</span>
        <el-input
          v-model="handler"
          placeholder="请输入申请人姓名"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">任务状态：</span>
        <el-cascader
          v-model="status"
          :options="taskStatusList"
          :props="taskStatusProps"
          class="select-input"
          clearable
          @change="taskStatusChange"
        />
      </li>
      <li>
        <span class="select-title">任务分配时间：</span>
        <el-date-picker
          v-model="startTime"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
      </li>

      <!-- <li>
        <span class="select-title">所属流程：</span>
        <el-cascader
          v-model="caseFlow"
          :options="processList"
          :props="taskStatusProps"
          class="select-input"
          clearable
          @change="processChange"
        />
      </li> -->
      <li>
        <span class="select-title">任务类型：</span>
        <el-cascader
          v-model="taskCode"
          :options="allTaskList"
          :props="taskStatusProps"
          class="select-input"
          clearable
          @change="allTaskChange"
        />
      </li>

      <li>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </li>
      <li />
      <li style="display: block; width: 100%">
        <el-button type="primary" icon="iconfont icon-daochu" @click="exportCase">
          导出
        </el-button>
        <el-button
          v-if="checkPermission('修改处理人', permList)"
          type="primary"
          icon="iconfont icon-biangeng"
          @click="changecase"
        >
          修改处理人
        </el-button>
        <el-button type="primary" icon="iconfont icon-chakanxiangqing" @click="seecase">
          查看详情
        </el-button>
        <el-button
          v-if="checkPermission('全部案件:导出标签', permList)"
          type="primary"
          icon="iconfont icon-daochu"
          @click="exportTag"
        >
          导出标签
        </el-button>
      </li>
    </ul>
    <el-table
      ref="multipleTable"
      :data="tableData.records"
      border
      tooltip-effect="dark"
      style="width: 100%; margin-top: 15px"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="50"
        align="center"
      />
      <el-table-column type="selection" width="60" align="center" />
      <el-table-column label="事件id" prop="caseId" width="150" align="center" />
      <el-table-column prop="reportTime" label="报案时间" width="180" align="center" />
      <el-table-column prop="startTime" label="任务开始时间" width="180" align="center" />
      <el-table-column prop="endTime" label="任务完成时间" width="180" align="center" />
      <el-table-column
        prop="recRealName"
        label="受助人姓名"
        align="center"
        width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="productName"
        label="所属计划"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="taskFlowName"
        label="任务所属流程"
        align="center"
        width="140"
        show-overflow-tooltip
      />
      <el-table-column
        prop="caseParentFlowName"
        label="事件状态"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="caseFlowName"
        label="当前处理状态"
        align="center"
        width="140"
        show-overflow-tooltip
      />
      <el-table-column
        prop="status"
        label="任务状态"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="handler"
        label="处理人"
        align="center"
        show-overflow-tooltip
      />
    </el-table>
    <div style="text-align: center; margin-top: 25px">
      <el-pagination
        :page-size="tableData.size"
        :current-page="pageIndex"
        background
        layout="total,prev, pager, next, jumper"
        :total="tableData.total"
        @current-change="pageChange"
      />
    </div>
    <el-dialog
      title="变更经办人"
      :visible.sync="dialogFormVisible"
      width="30%"
      custom-class="c-p"
    >
      <el-tree
        :data="dialogData"
        :props="defaultProps"
        accordion
        @node-click="changeOperator"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      loading: true,
      accessRole: 'ACCESS_MINE',
      limit: 10,
      pageIndex: 1,
      caseId: '',
      handler: '',
      status: null,
      startTime: '',
      realName: '',
      idCard: '',
      caseFlow: '', // 所属流程（已废除）
      taskCode: '', // 任务类型

      optionProps: {
        expandTrigger: 'hover',
        emitPath: false,
        multiple: true,
        value: 'flowCode',
        label: 'name',
        children: 'children'
      },
      tableData: {},
      selectRows: [],
      dialogData: [],
      dialogFormVisible: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentCode: '',
      formLabelWidth: '120px',
      taskStatusList: [],
      taskStatusProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'code',
        label: 'name',
        children: 'children'
      },
      // 所属流程
      processList: [
        { code: 101020, name: '【公估-回访】' },
        { code: 100020, name: '【初审回访客诉子任务】' },
        { code: 100513, name: '【缴费回访客诉子任务】' },
        { code: 100599, name: '【是否去调查子任务】' },
        { code: 103001, name: '【确认结果客诉子任务】' },
        { code: 101520, name: '【补资料回访子任务】' }
      ],

      // 任务类型
      allTaskList: [
        { code: 'T0002', name: '【公估-回访】' },
        { code: 'T0005', name: '【初审回访客诉子任务】' },
        { code: 'T0006', name: '【缴费回访客诉子任务】' },
        { code: 'T0007', name: '【是否去调查子任务】' },
        { code: 'T0008', name: '【确认结果客诉子任务】' },
        { code: 'T0009', name: '【补资料回访子任务】' },
        { code: 'T0010', name: '【初审补资料回访子任务】' },
        { code: 'T0012', name: '【调查回访子任务】' }
      ]
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    selectRowsId() {
      const idArr = []
      if (this.selectRows.length > 0) {
        this.selectRows.filter((item) => {
          idArr.push(item.userId)
        })
      }
      return idArr
    }
  },

  created() {
    this.$emit('setCurrentMenu', '我的任务')

    const currentmyTaskSearchData = JSON.parse(
      localStorage.getItem('currentmyTaskSearchData')
    )
    if (currentmyTaskSearchData) {
      this.accessRole = currentmyTaskSearchData.accessRole
      this.limit = currentmyTaskSearchData.limit
      this.pageIndex = currentmyTaskSearchData.pageIndex
      this.caseId = currentmyTaskSearchData.caseId
      this.handler = currentmyTaskSearchData.handler
      this.status = currentmyTaskSearchData.status
      this.startTime = currentmyTaskSearchData.startTime
      this.realName = currentmyTaskSearchData.realName
      this.idCard = currentmyTaskSearchData.idCard
      this.caseFlow = currentmyTaskSearchData.caseFlow
      this.taskCode = currentmyTaskSearchData.taskCode
    }

    this.getTaskList(
      this.accessRole,
      this.limit,
      this.pageIndex,
      this.caseId,
      this.handler,
      this.status,
      this.startTime,
      this.realName,
      this.idCard,
      this.caseFlow,
      this.taskCode
    )
    this.getTaskStatus()
  },

  methods: {
    getTaskStatus() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case-task/status-enum')
        .then((res) => {
          if (res.data.status === '000000') {
            const resdata = res.data.data
            vm.taskStatusList = resdata
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    taskStatusChange(val) {
      this.status = val
    },

    /**
     * 监听所属流程的选项变化事件（已废除）
     */
    processChange(val) {
      this.caseFlow = val
    },

    /**
     * 监听任务类型的选项变化事件
     */
    allTaskChange(val) {
      this.taskCode = val
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    /**
     * 子任务-列表
     */
    getTaskList(
      accessRole,
      limit,
      page,
      caseId,
      handler,
      status,
      startTime,
      realName,
      idCard,
      caseFlow,
      taskCode
    ) {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case-task/list', {
          params: {
            accessRole,
            limit,
            page,
            caseId,
            handler,
            status,
            startTime,
            realName,
            idCard,
            caseFlow,
            taskCode
          }
        })
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.loading = false
            vm.tableData = data.page
          } else {
            vm.$alert(data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    search() {
      this.pageIndex = 1
      this.getTaskList(
        this.accessRole,
        this.limit,
        this.pageIndex,
        this.caseId,
        this.handler,
        this.status,
        this.startTime,
        this.realName,
        this.idCard,
        this.caseFlow,
        this.taskCode
      )
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },

    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    selectionChange(rows) {
      this.selectRows = rows
    },

    changeOperator(val) {
      this.currentCode = val.code
    },

    seecase() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      const currentmyTaskSearchData = {
        accessRole: vm.accessRole,
        limit: vm.limit,
        pageIndex: vm.pageIndex,
        caseId: vm.caseId,
        handler: vm.handler,
        status: vm.status,
        startTime: vm.startTime,
        realName: vm.realName,
        idCard: vm.idCard,
        caseFlow: vm.caseFlow,
        taskCode: vm.taskCode
      }
      localStorage.setItem(
        'currentmyTaskSearchData',
        JSON.stringify(currentmyTaskSearchData)
      )
      this.$router.push({
        path: '/index/caseDetailV2/' + vm.selectRows[0].caseCode,
        query: {
          from: 'mytask',
          taskCode: vm.selectRows[0].taskCode,
          taskVersion: vm.selectRows[0].taskVersion
        }
      })
    },

    pageChange(val) {
      this.pageIndex = val
      this.getTaskList(
        this.accessRole,
        this.limit,
        this.pageIndex,
        this.caseId,
        this.handler,
        this.status,
        this.startTime,
        this.realName,
        this.idCard,
        this.caseFlow,
        this.taskCode
      )
    },

    changecase() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      vm.axios
        .get(vm.homePath() + '/case-task/modify-user-list/' + vm.selectRows[0].taskCode)
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.dialogData = vm.filterNull(vm.toTreeData(data.data, 'parentCode', 'code'))
            vm.dialogFormVisible = true
          } else {
            vm.$alert(data.message)
          }
        })
        .catch((error) => console.log(error))
    },

    save() {
      const postData = {
        taskCode: this.selectRows[0].taskCode,
        taskVersion: this.selectRows[0].taskVersion,
        userId: this.currentCode
      }

      this.axios
        .post(this.homePath() + '/case-task/modify-user', postData)
        .then((response) => {
          this.dialogFormVisible = false
          if (response.data.status === '000000') {
            this.$alert('更改成功', '提示', {
              callback: () => {
                this.getTaskList(
                  this.accessRole,
                  this.limit,
                  this.pageIndex,
                  this.caseId,
                  this.handler,
                  this.status,
                  this.startTime,
                  this.realName,
                  this.idCard
                )
              }
            })
          } else {
            this.$alert(response.data.message)
          }
        })
        .catch((error) => console.log(error))
    },

    exportCase() {
      window.location.href =
        this.homePath() +
        '/case-task/excelExport?realName=' +
        (this.realName == null ? '' : this.realName) +
        '&caseId=' +
        (this.caseId == null ? '' : this.caseId) +
        '&status=' +
        (this.status == null ? '' : this.status) +
        '&startTime=' +
        (this.startTime == null ? '' : this.startTime) +
        '&limit=' +
        (this.limit == null ? '' : this.limit) +
        '&page=' +
        (this.pageIndex == null ? '' : this.pageIndex) +
        '&caseFlow=' +
        (this.caseFlow == null ? '' : this.caseFlow) +
        '&taskCode=' +
        (this.taskCode == null ? '' : this.taskCode) +
        '&handler=' +
        (this.handler == null ? '' : this.handler) +
        '&accessRole=' +
        this.accessRole +
        '&time=' +
        new Date().valueOf()
    },

    /**
     * 导出标签
     */
    exportTag() {
      const {
        accessRole,
        realName: recRealName,
        idCard: recIdno,
        caseId
      } = this

      // 以下参数为空
      const flowCode = '' // 案件流程
      const createTime = '' // 待办日期
      const operatorTime = '' // 操作时间
      const applicantName = '' // 申请人姓名
      const caseTag = '' // 案件标签
      const accidentType = '' // 事故类型
      const currentProcessAccount = '' // 当前处理账号

      window.location.href = this.homePath() + '/case/exportTag?accessRole=' + accessRole + '&recRealName=' + recRealName +
      '&recIdno=' + recIdno + '&flowCode=' + flowCode + '&createTime=' + createTime + '&operatorTime=' + operatorTime +
      '&applicantName=' + applicantName + '&caseId=' + caseId + '&caseTag=' + caseTag + '&accidentType=' + accidentType +
      '&currentProcessAccount=' + currentProcessAccount
    }
  }
}
</script>

<style></style>
